import TaskAspectCalculateDoneNotification from 'app/admin/notification/component/TaskAspectCalculateDoneNotification';
import TaskOptimizeDoneNotification from 'app/admin/notification/component/TaskOptimizeDoneNotification';
import TaskWhatIfCalculateDoneNotification from 'app/admin/notification/component/TaskWhatIfCalculateDoneNotification';
import UserNotification from 'app/admin/notification/component/UserNotification';

const NotificationRepo = {
	User: UserNotification,
	TaskAspectCalculateDone: TaskAspectCalculateDoneNotification,
	TaskWhatIfCalculateDone: TaskWhatIfCalculateDoneNotification,
	TaskOptimizeDone: TaskOptimizeDoneNotification
};
export default NotificationRepo;
